import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../../../components/ui/atoms/button';
import finairaLogo from '../../../assets/images/FinairaLogo.png';
import { useAuth } from '../../../contexts/AuthContext';
import { authApi } from '../../../api/auth';

import logo from '../../../assets/images/Tempus-Text-Light-2.png';
import logoDark from '../../../assets/images/Tempus-Text-Dark-2.png';
import { BrandingPanel } from './components';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export function LoginPage() {
  const { receiveToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showDevUsers, setShowDevUsers] = useState(false);

  const handleMicrosoftSignIn = () => {
    window.location.href = `${API_BASE}/api/v1/auth/microsoft`;
  };

  // TODO(remove-before-commit): DEV-ONLY SSO BYPASS — DELETE ONCE TENANT
  // ADMIN HAS CONFIGURED THE MICROSOFT APP REGISTRATION
  const handleDevBypass = async (user: 'magued' | 'phillip') => {
    setError('');
    setIsLoading(true);
    try {
      const { data } = await authApi.devBypass(user);
      receiveToken(data.accessToken);
      navigate('/employee/entries', { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Dev bypass failed — is the backend running?');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen">
      <BrandingPanel />

      {/* Right panel */}
      <div className="flex flex-1 flex-col items-center justify-center p-8 bg-background">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-4 bg-white rounded-2xl justify-center flex flex-col items-center py-3 shadow-black/20">
            <img src={logo} alt="Tempus" className="h-auto w-40" />
            <div className="flex items-center justify-center gap-2 px-3 mt-2">
              <span className="whitespace-nowrap text-[10px] font-semibold uppercase tracking-widest text-slate-400 dark:text-slate-500">
                Powered by
              </span>
              <img src={finairaLogo} alt="Finaira" className="h-3 w-auto" />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-foreground mb-1">Welcome back</h1>
          <p className="text-muted-foreground text-sm mb-8">Sign in to your Finaira account to continue</p>

          <div className="bg-card rounded-xl border border-border shadow-sm p-6 space-y-4">
            <Button
              onClick={handleMicrosoftSignIn}
              className="w-full text-white border-none"
              style={{ background: 'linear-gradient(135deg, #444ab2 0%, #459fec 100%)' }}
            >
              Sign in with Microsoft
            </Button>

            {error && (
              <div className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">
                {error}
              </div>
            )}

            {/* TODO(remove-before-commit): DEV-ONLY SSO BYPASS — DELETE ONCE TENANT
                ADMIN HAS CONFIGURED THE MICROSOFT APP REGISTRATION */}
            {process.env.NODE_ENV !== 'production' && (
              <div className="space-y-2">
                <Button
                  onClick={() => setShowDevUsers((current) => !current)}
                  disabled={isLoading}
                  variant="outline"
                  className="w-full border-dashed border-red-400 text-red-600 hover:bg-red-50"
                >
                  Dev Bypass (temporary)
                </Button>

                {showDevUsers && (
                  <div className="grid grid-cols-2 gap-2">
                    <Button onClick={() => handleDevBypass('magued')} disabled={isLoading} variant="outline">
                      Magued
                    </Button>
                    <Button onClick={() => handleDevBypass('phillip')} disabled={isLoading} variant="outline">
                      Phillip
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

